import { render, staticRenderFns } from "./DispatcherHistory.vue?vue&type=template&id=3ca1c1a8&scoped=true&"
import script from "./DispatcherHistory.vue?vue&type=script&lang=js&"
export * from "./DispatcherHistory.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherHistory.vue?vue&type=style&index=0&id=3ca1c1a8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1c1a8",
  null
  
)

export default component.exports